import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as logoRailStyles from "./LogoRail.module.css";

const LogoRail = ({ props }) => {
  const { howManyLogosInARow, logos } = props;

  const cols = `row${howManyLogosInARow || 4}`;

  return (
    <div className={`${logoRailStyles.logoRail} ${logoRailStyles[cols]}`}>
      {logos.map((logo, index) => {
        const logoFile = logo && getImage(logo.file);
        return <GatsbyImage key={index} image={logoFile} alt={logo.alt} />;
      })}
    </div>
  );
};

export default LogoRail;
